import React, { Component } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { AddCamps,
        deleteCamp,
        UpdateCuratedCampsByAdmin ,
        CuratedCampDetails,
        emailExist_check, 
        getLocationList,
        getSearchList,
        partnerMainCategory,
        partnerSubCategories,
        partnerCategory } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
 
import Geocode from "react-geocode";

import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR, MOBILE_REGEX, URL_REGEX, IMGBASEURL} from '../../constant';

import Autosuggest from 'react-autosuggest';
import SimpleReactValidator from 'simple-react-validator';
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();


class bewiseEditCuratedCamp extends Component {

   constructor(props) {
        super(props);
        let qrystr = window.location.search;
        const urlParams = new URLSearchParams(qrystr);
        let sid = urlParams.get('sid');
        this.state = {
            formValues: [{ name: "",
                              pid:"", 
                              enddate : "",
                              fromdate : "",
                              starttime : "",
                              endtime : "",
                              feeinr : "",
                              feeusd : "",
                              duration : "",
                              days : "",
                              participants:"" }],
            sid: sid != null ? sid : -1,
            category_data: [],
            subcategoriesselected:[],
            totalcategoryselected:[],
            preselectsubcategories:[],
            sub_categorycollected:[],
            mainvendorcategory:[],
            subcategory_data: [],
            AgeList: [],
            showsuggest:false,
            suggestions:'',
            errors:[],
            about_camp:'',
            about_partner:'',
            pageid: '',
            invities: '',
            latitude: '',
            longitude: '',
            other_rating: '',
            student_ratio: '',
            approval_status:'',
            tution_type: '',
            vendor_id:'',
            tutionList: [],
            attachment_file: [],
            attachment_file_length: 0,
            attachment_fileName: [],
            edit_banner: '',
            profile_image:'',
            edit_profile_image:'',
            edit_brochure:'',
            delete_array: [],
            categorySubTypeList: [],
            sub_type: '',
            cat_type: false,
            tempBanner: '',
            tempProfile:'',
            tempBrochure:'',
            has_trail: 0,
            trail_desc: '',
            location_list: [],
            value:'',
            partner_type: '',
            prerequisites:'',
            programs:[],
            program_duration: [{ name: "" }],
            program_days: [{ name: "" }],
            program_names: [{ name: "" }],
            program_todates: [{ name: "" }],
            program_fromdates: [{ name: "" }],
            program_starttime: [{ name: "" }],
            program_endtime: [{ name: "" }],
            program_feeinr: [{ name: "" }],
            program_feeusd: [{ name: "" }],
            vendor_id:'',
            files:[],
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
        }
        this.validator = new SimpleReactValidator({
            validators: {
                checkExist: {  // name the rule
                    message: 'The :attribute field is required.',
                    rule: (val, params, validator) => {
                        if (val == '' && this.state.edit_image == '') {
                            return false;
                        }
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                emailExist_check: {  // name the rule
                    message: 'The :attribute Already Exist.',
                    rule: (val, params, validator) => {
                        return this.state.isEmailValid;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                checkMobile: MOBILE_REGEX,
                checkUrl: URL_REGEX
            }
        });
        
        
        this.tutionList();
        this.camp_id = this.props.match.params.camp_id ? this.props.match.params.camp_id : '';
        if (this.camp_id !== undefined) {
            this.CuratedCampDetails = this.CuratedCampDetails.bind(this);
            this.CuratedCampDetails(this.camp_id);

        }

        this.loadFile = this.loadFile.bind(this)
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.handleEditorPartnerChange = this.handleEditorPartnerChange.bind(this);
        this.handleCustomeSelect = this.handleCustomeSelect.bind(this);
        //this.handleSubCatSelect = this.handleSubCatSelect.bind(this);

        this.handleEditorPrerequisites = this.handleEditorPrerequisites.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    deleteCamp(i, e) {
      
        if(window.confirm("Are you sure?")){

            let req_c = JSON.stringify({
                camp_id: this.camp_id
            });
            let THIS = this;
            let toastr = '';
            deleteCamp(req_c).then(async res => {
                if (res.status === 1) {
                        
                    toastr = window.toastr.success;
                    toastr('', res.message, {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                    this.props.history.push('/admincuratedcamps');

                }
            })

        }

    }


    handleChangev1(i, e) {
        let formValues = this.state.formValues;
        formValues[i][e.target.name] = e.target.value;
        this.setState({ formValues });
    }

     addFormFieldsv1() {
        this.setState(({
         formValues: [...this.state.formValues, {
                              pid:"",   
                              name: "", 
                              enddate : "",
                              fromdate : "",
                              starttime : "",
                              feeinr : "",
                              feeusd : "",
                              duration : "",
                              days : "",
                              participants : "" }]
     }))
    }


    removeFormFieldsv1(i) {
        let formValues = this.state.formValues;
        formValues.splice(i, 1);
        this.setState({ formValues });
    }

getMainCategoryDataVendor= async (vendor_id) => {
    const { user_type, login_id, set_id } = this.state.user_data;
    let sid = this.state.sid != -1 ? this.state.sid : set_id;
    let req_c = JSON.stringify({
      partner_id: vendor_id,
      sid: 1,
      category_id: 0,
      url: 'partner_main_category_data'
    });
    let THIS = this;
    await partnerMainCategory(req_c).then(async res_c => {
      if (res_c.status === 1) {
        this.setState({
          sid: sid,
          mainvendorcategory: res_c.category_data.result        
        })
      }
    })

    this.setState({
      checking: true
    })
    setTimeout(function () {
      THIS.setState({
        checking: false
      })
    }, 5000)
  }

  getMainCategoryData = async () => {
    const { user_type, login_id, set_id } = this.state.user_data;
    let sid = this.state.sid != -1 ? this.state.sid : set_id;
    let req_c = JSON.stringify({
      partner_id: login_id,
      sid: this.state.sid != -1 ? this.state.sid : set_id,
      category_id: 0,
      url: 'partner_main_category_data'
    });
    let THIS = this;
    await partnerMainCategory(req_c).then(async res_c => {
      if (res_c.status === 1) {
        this.setState({
          sid: sid,
          mainvendorcategory: res_c.category_data.result        
        })
      }
    })

    this.setState({
      checking: true
    })
    setTimeout(function () {
      THIS.setState({
        checking: false
      })
    }, 5000)
  }

    handleEditorChange(value, editor) {
        //console.log(value);
        this.setState({
          about_camp: value
        });
    }
    handleEditorPartnerChange(value, editor) {
        //console.log(value);
        this.setState({
          about_partner: value
        });
    }

    handleEditorAbout(value, editor) {
        //console.log(value);
        this.setState({
          about_camp: value
        });
    }

    handleEditorParnter(value, editor) {
        //console.log(value);
        this.setState({
          about_partner: value
        });
    }


    handleEditorPrerequisites(value, editor) {
        //console.log(value);
        this.setState({
          prerequisites: value
        });
    }


    fileSelectedHandler = (e) => {
        this.setState({ files: [...this.state.files, ...e.target.files] })
    }

    handleProgramNameChange = (idx) => (evt) => {
   
    const newPrograms = this.state.program_names.map((programs, sidx) => {

      if (idx !== sidx) return programs;
      return { ...programs, name: evt.target.value };
    });

    this.setState({ program_names: newPrograms });
    };


    async CuratedCampDetails(camp_id) {
        if(camp_id!=''){
        let response = await FetchCall.getCuratedCampInfo(camp_id);
        if (response.status === 1) {
 
            const data = response.result;

            this.setState({
                vendor_id: data.vendor_id,
                camp_name: data.camp_name,
                categories: data.categories.split(","),
                approval_status: data.approval_status,
                published: data.published,
                student_ratio: data.student_ratio,
                tution_type: data.tution_type,
                contact_person: data.contact_person,
                phone_number: data.phone_number,
                email_id: data.email_id,
                prerequisites:data.prerequisites,
                about_camp: data.about,
                about_partner:data.about_partner,
                edit_banner: data.banner ? data.url + data.banner : '',
                edit_profile_image: data.profile_image ? data.url + data.profile_image : '',
                edit_brochure: data.brochure ? data.url + data.brochure : '',
                attachment_file: data.photo_arr,
                edit_photos: data.gallery
            });

            let formValues = [];
            for(var i=0;i<data.program_names.length;i++){
            formValues.push({
                pid:data.program_ids[i],
                name:data.program_names[i],
                enddate:data.program_todates[i],
                fromdate:data.program_fromdates[i],
                starttime:data.program_starttime[i],
                endtime:data.program_endtime[i],
                feeinr:data.program_feeinr[i],
                feeusd:data.program_feeusd[i],
                duration:data.program_duration[i],
                days:data.program_days[i],
                participants:data.program_noofparticipants[i]
            })
            }

            this.setState({ formValues });
            //this.setState({ programs });
            this.getMainCategoryDataVendor(data.vendor_id);           
        } else {
            this.props.history.push('/admincuratedcamps');
        }
        }
    }

    handleProgramDuration = (idx) => (evt) => {
    const newPrograms = this.state.program_duration.map((program, sidx) => {
      if (idx !== sidx) return program;
      return { ...program, name: evt.target.value };
    });

    this.setState({ program_duration: newPrograms });
    };

    handleProgramDays = (idx) => (evt) => {
    const newPrograms = this.state.program_days.map((program, sidx) => {
      if (idx !== sidx) return program;
      return { ...program, name: evt.target.value };
    });

    this.setState({ program_days: newPrograms });
    };
      

    handleProgramFDChange= (idx) => (evt) => {
    const newPrograms = this.state.program_fromdates.map((program, sidx) => {
      if (idx !== sidx) return program;
      return { ...program, name: evt.target.value };
    });

    this.setState({ program_fromdates: newPrograms });
    };

   onChange = (event, { newValue, method }) => {

        this.setState({
            value: newValue,
            showsuggest: false,

        });
    };


    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method } ) => {
        $("#vendor_id").val(suggestion.vendor_id);
        //alert(suggestion.vendor_id);
        this.setState({
            login_id: suggestion.vendor_id
        });
    };


    handleProgramEDChange= (idx) => (evt) => {
    const newPrograms = this.state.program_todates.map((program, sidx) => {
      if (idx !== sidx) return program;
      return { ...program, name: evt.target.value };
    });

    this.setState({ program_todates: newPrograms });
    };

  
    handleProgramSTChange= (idx) => (evt) => {
    const newPrograms = this.state.program_starttime.map((program, sidx) => {
      if (idx !== sidx) return program;
      return { ...program, name: evt.target.value };
    });

    this.setState({ program_starttime: newPrograms });
    };
    handleProgramETChange= (idx) => (evt) => {
    const newPrograms = this.state.program_endtime.map((program, sidx) => {
      if (idx !== sidx) return program;
      return { ...program, name: evt.target.value };
    });

    this.setState({ program_endtime: newPrograms });
    };
    handleProgramINRChange= (idx) => (evt) => {
    const newPrograms = this.state.program_feeinr.map((program, sidx) => {
      if (idx !== sidx) return program;
      return { ...program, name: evt.target.value };
    });

    this.setState({ program_feeinr: newPrograms });
    };
    handleProgramUSDChange= (idx) => (evt) => {
    const newPrograms = this.state.program_feeusd.map((program, sidx) => {
      if (idx !== sidx) return program;
      return { ...program, name: evt.target.value };
    });

    this.setState({ program_feeusd: newPrograms });
    };

    handleAddProgram = () => {
    this.setState({
      program_ids: this.state.program_ids.concat([{ name: "" }]),  
      program_names: this.state.program_names.concat([{ name: "" }]),
      program_fromdates: this.state.program_fromdates.concat([{ name: "" }]),
      program_todates: this.state.program_todates.concat([{ name: "" }]),
      program_starttime: this.state.program_starttime.concat([{ name: "" }]),
      program_endtime: this.state.program_endtime.concat([{ name: "" }]),
      program_feeinr: this.state.program_feeinr.concat([{ name: "" }]),
      program_feeusd: this.state.program_feeusd.concat([{ name: "" }]),
      program_duration: this.state.program_duration.concat([{ name: "" }]),
      program_days: this.state.program_days.concat([{ name: "" }]),
      program_noofparticipants: this.state.program_noofparticipants.concat([{ name: "" }]),
    });
    };

  handleRemoveProgram = (idx) => () => {
    this.setState({
      program_ids: this.state.program_ids.filter((s, sidx) => idx !== sidx),
      program_names: this.state.program_names.filter((s, sidx) => idx !== sidx),
      program_fromdates: this.state.program_fromdates.filter((s, sidx) => idx !== sidx),
      program_todates: this.state.program_todates.filter((s, sidx) => idx !== sidx),
      program_starttime: this.state.program_starttime.filter((s, sidx) => idx !== sidx),
      program_endtime: this.state.program_endtime.filter((s, sidx) => idx !== sidx),
      program_feeinr: this.state.program_feeinr.filter((s, sidx) => idx !== sidx),
      program_feeusd: this.state.program_feeusd.filter((s, sidx) => idx !== sidx),
      program_duration: this.state.program_duration.filter((s, sidx) => idx !== sidx),
      program_days: this.state.program_days.filter((s, sidx) => idx !== sidx),
      program_noofparticipants: this.state.program_noofparticipants.filter((s, sidx) => idx !== sidx),
    });
  };

    LocationDataList = async () => {
        try {
            const res = await getLocationList();
            if (res.status == 1) {
 

                this.setState({
                    location_list: res.results,
                    error: false
                });
            }

        } catch (error) {
            this.setState({ error: true });
        }
    };
    validateMail = (value, catgry, vendr_id, pageid) => {
        let name = 'email_id';
        let type_name = 'isEmailValid';
        let req = JSON.stringify({
            [name]: value,
            category: catgry,
            vendor_id: vendr_id,
            pageid: pageid
        });
        let res = emailExist_check(req).then(res => {
 
            if (res.status === 1) {
                this.setState({
                    [type_name]: false
                });
            } else {
                // return res.status;
                this.setState({
                    [type_name]: true
                });
            }
        });
    }
    async tutionList() {
        let response = await FetchCall.getSchoolListDatas('tution_type');
 
        if (response) {
            this.setState({ tutionList: response.results });
        }
    }
    async getAgelist() {
        let response = await FetchCall.getSubCategory('8');
 
        if (response) {
            this.setState({ AgeList: response.results });
        }
    }

    async Sub_Cat_type() {
        let response = await FetchCall.getSchoolListDatas('age_group');
        if (response.status == 1) {
            this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
        } else {
            this.setState({ cat_type: false });
        }
    }
    componentDidMount() {

        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        this.setState({ vendor_id: vendor_id });
       
    }
    UNSAFE_componentWillMount() {

    }
    componentDidUpdate() {
        window.jQuery('.selectpicker').selectpicker('refresh')
    }

    handleSelect = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);
        this.Sub_Cat_type(value);
        this.setState({ [propName]: value });
   
        if(value==184){
            $("#curatedcampskeyinfo").removeClass('hidden');
        }

    };

    duplicaterow= (e) => {
        

    }

    handleSelectCat1 = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);
        this.setState({ [propName]: value });

    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        this.Geocode_location();
        const propName = e.target.name;
        // if (propName == 'email_id') {
        //     this.validateMail(e.target.value, 8, this.state.vendor_id, this.state.pageid);
        // }
    };

    handleBrochureFile = (e) => {
        // this.Geocode_location();
        const propName = e.target.name;
        const files = e.target.files[0];
        this.setState({ [propName]: files });
        const reader = new FileReader();
        let pdf = '';
        let THIS = this;
        reader.addEventListener("load", function () {
            // convert image file to base64 string
            pdf = reader.result;
            THIS.setState({
                tempBrochure: reader.result
            });
        }, false);

        if (files) {
            reader.readAsDataURL(files);
        } else {
            THIS.setState({
                tempBrochure: ''
            });
        }
    };
    handleFile = (e) => {
        // this.Geocode_location();
        const propName = e.target.name;
        const files = e.target.files[0];
        this.setState({ [propName]: files });
        const reader = new FileReader();
        let img = '';
        let THIS = this;
        reader.addEventListener("load", function () {
            // convert image file to base64 string
            img = reader.result;
            THIS.setState({
                tempBanner: reader.result
            });
        }, false);

        if (files) {
            reader.readAsDataURL(files);
        } else {
            THIS.setState({
                tempBanner: ''
            });
        }
    };

    handleProFile = (e) => {
        // this.Geocode_location();
        const propName = e.target.name;
        const files = e.target.files[0];
        this.setState({ [propName]: files });
        const reader = new FileReader();
        let img = '';
        let THIS = this;
        reader.addEventListener("load", function () {
            // convert image file to base64 string
            img = reader.result;
            THIS.setState({
                tempProfile: reader.result
            });
        }, false);

        if (files) {
            reader.readAsDataURL(files);
        } else {
            THIS.setState({
                tempProfile: ''
            });
        }
    };
    handleFileMultiple = (e) => {
        this.setState({ [e.target.name]: e.target.files });
    };

    handleGallery = (e) => {
        this.setState({ [e.target.name]: e.target.files[0] });
    };

    Geocode_location(location = '') {
        Geocode.fromAddress(location ? location : this.state.google_location).then(
            response => {
                const { lat, lng } = response.results[0].geometry.location;
                if (lat && lng)
                    this.get_location(lat, lng);
            },
            error => {
                console.error(error);
            }
        );

    }



    escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }


    getSuggestions = async (value) => {
        const escapedValue = this.escapeRegexCharacters(value.trim());
        let list = await this.getSearchListFetch(escapedValue);
        var final = [];
        if (list.status === 1) {
            final = list.list
            this.setState({
                searchList: list.list
            })
        } else {
            final = [];
        }
        return final;
    }
    getSearchListFetch = (val) => {
        let data = JSON.stringify({
            keyword: val,
            city: 'bengaluru',
        })
        return getSearchList(data).then(response => response);
    }
    shouldRenderSuggestions = (value, reason) => {
        return value.trim().length > 2;
    };
    getSuggestionValue(suggestion) {
        
        return suggestion.name;
    }

    renderSuggestion(suggestion) {
        return (
            <span>{suggestion.name}</span>
        );
    }

    searchLink = (e) => {
        e.preventDefault();

        let search_text = this.state.value;
        if (search_text.length > 3) {
            //console.log('search_text',search_text)
            var search = search_text.split(' ').join('+');
            window.location.replace('/search/' + search);
        }
        // localStorage.setItem("searchdata", search_text);
    }
    onSuggestionsFetchRequested = ({ value }) => {
        this.getSuggestions(value).then(response => {
            this.setState({
                suggestions: response
            });
        })
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            login_id:'',
            suggestions: []
        });
    };

    get_location(lat, lng) {
        this.setState({
            latitude: lat,
            longitude: lng
        });
    }
    handleSubCatSelect= async (e, i, name) => {

    const propName = e.target.name;
    var value = [...e.target.selectedOptions].map((item) => item.value);
    let subcategoriesselected = this.state.subcategoriesselected;

    //subcategoriesselected[propName] = value;

    subcategoriesselected[i] = value;

    this.setState({ subcategoriesselected });

    };

    handleCustomeSelect = async (e, name) => {

    const propName = e.target.name;
    //alert(e.target.attr('data-cat'));
    var value = [...e.target.selectedOptions].map((item) => item.value);
    var category_ids = [...e.target.selectedOptions].map((item) => item.getAttribute('data-cat'));
    let totalcategoryselected = this.state.totalcategoryselected;
  
    const arrays = String(value).split(",");
    const cat_arrays = String(category_ids).split(",");

    for(var i=0;i<arrays.length;i++){
        totalcategoryselected[i] = arrays[i];
        this.setState({ totalcategoryselected });
        this.getSubCategory(category_ids[i], i);
    }

    this.setState({ totalcategoryselected });

  };

  

  getSubCategoryEdit = async (cat_id,ind) => {
    let req_c = JSON.stringify({
      parent_category: cat_id,
      url: 'partner_sub_categories'
    });
    let sub_categorycollected = this.state.sub_categorycollected;
    let THIS = this;
    await partnerSubCategories(req_c).then(async res_c => {
      if (res_c.status === 1) {
        sub_categorycollected[ind] =res_c.category_data.result;
        this.setState({sub_categorycollected});
      }
    })
  }

  getSubCategory = async (cat_id,ind) => {
    let req_c = JSON.stringify({
      parent_category: cat_id,
      url: 'partner_sub_categories'
    });
    let sub_categorycollected = this.state.sub_categorycollected;
    let THIS = this;
    await partnerSubCategories(req_c).then(async res_c => {
      if (res_c.status === 1) {
        sub_categorycollected[ind] =res_c.category_data.result;
        this.setState({sub_categorycollected});
      }
    })
  }
  

  checkHasSubCategory = async (current_arr, ele) => {
    let checkId = (ele == 'second_category') ? current_arr.first_category_id : current_arr.second_category_id;
    let THIS = this;
    const arr = (ele == 'second_category') ? current_arr.first_list : current_arr.second_category;
    console.log('checkId', arr)
    let temp = arr.filter((item) => item.is_parent == 1 && checkId.includes(item['category_id'].toString()));
    console.log('*** temp', temp)
    if (temp.length === 1) {
      let item = temp[0];
      console.log('checkId came inside', item['category_id'])
      current_arr = await this.getCategory(item['category_id'], ele, current_arr);
      current_arr['second_lbl'] = item['category_name'];
    }
    this.setState({
      checking: true
    })
    setTimeout(function () {
      THIS.setState({
        checking: false
      })
    }, 500)
    return current_arr;
  }
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
  };
    handleSubmit = (e) => {
        e.preventDefault();

        //console.log("nae1", e.target.program_name);
        
        if (this.validator.allValid()) {
            let insData = {
                camp_id:this.camp_id,
                approval_status:this.state.approval_status,
                published:this.state.published,
                about:this.state.about_camp,
                camp_name:this.state.camp_name,
                formValues:JSON.stringify(this.state.formValues)
                /*
                program_names : JSON.stringify(this.state.formValues.name),
                program_todates: JSON.stringify(this.state.formValues.enddate),
                program_fromdates: JSON.stringify(this.state.formValues.fromdate),
                program_starttime: JSON.stringify(this.state.formValues.starttime),
                program_endtime: JSON.stringify(this.state.formValues.endtime),
                program_feeinr: JSON.stringify(this.state.formValues.feeinr),
                program_feeusd: JSON.stringify(this.state.formValues.feeusd),
                program_duration: JSON.stringify(this.state.formValues.duration),
                program_days: JSON.stringify(this.state.formValues.days),
                */
            }

            console.log('insData',insData);

            // return false;
            // jQuery("#btnSubmit").attr('disabled', true);
            
            UpdateCuratedCampsByAdmin(insData).then((res) => {
                let toastr = '';
                if (res.status === 1) {

                    toastr = window.toastr.success;
                    toastr('', res.message, {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                    this.props.history.push('/bewise_curated_list');
                } else {
                    jQuery("#btnSubmit").attr('disabled', false);
                    toastr = window.toastr.error; //warning
                    toastr('Error', 'Something went wrong. try again!...', {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                }
            });
            
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

  
  removeImage = e => {
        var delete_array = this.state.delete_array;
        delete_array.push(e)
        const updated = this.state.attachment_file.filter(item => item.name !== e)
        this.setState({
            attachment_file: updated,
            delete_array: delete_array,
        })
    }

    clearValidationErr(elm) {
        this.setState((prevState) => {
            let newArr = [];
            for (let err of this.state.errors) {
                if (elm !== err.elm) {
                    newArr.push(err);
                }
            }
            return { errors: newArr };
        })
    }

    remove_img() {
        jQuery('#edit_image').remove();
    }
    loadFile(e) {
        var files = e.target.files
        this.setState({ attachment_file_length: files.length })
        if (files.length > 0) {
            jQuery('.upload-space').addClass('hide')
            jQuery('.upload-thumb').removeClass('hide')
            var fileArra = this.state.attachment_file

            //console.log('fileArra',fileArra)
            //var fileThumbArra = this.state.imgThumb;
            for (var i = 0; i < files.length; i++) {
                fileArra.push(e.target.files[i])
                this.setState({
                    selectedFile: URL.createObjectURL(e.target.files[i]),
                    attachment_file: fileArra
                })
            }
            this.clearValidationErr('attachment_file');
        }
    }


    createSelectItems(category) {
     let items = [];   
     let array = this.state.sub_categorycollected;
      
     if(array[category]!=undefined){

        let arra = array[category];
        arra.forEach((ele,index)=>{
            items.push(<option value={ele.category_id}>{ele.category_name}</option>);   
     
        })

     }
         
     return items;
    }  

    render() {

        const { value, suggestions, mainvendorcategory,totalcategoryselected, sub_categorycollected} = this.state;
              
        const { role, user_name } = this.state.auth_data;

        const inputProps = {
            placeholder: "Search for a partner",
            value,
            class: 'd-search-text form-control',
            id: 'searchbanner',
            className:'form-control',
            onChange: this.onChange,
            ref: this.wrapperRef,
            onClick: () => {
                this.setState({
                    showsuggest: true
                })
            }
        };


        this.validator.purgeFields();

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">BeWise Curated Camps</h4>
                 
       
                  <div class="row col-lg-12">
                    
                          <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                                    <div className="tab-content">
                                        <div id="company-info" className="tab-pane in active">
                                            <form onSubmit={this.handleSubmit} className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <input type="hidden" name="vendor_id" value={this.state.vendor_id} />
                                                        <div className="form-group col-md-6">
                                                            <label>Camp Name <span className="astrick">*</span></label>
                                                            <input type="text" name="camp_name"
                                                                value={this.state.camp_name} 
                                                                className="form-control" onChange={this.handleChange} />
                                                           
                                                        </div>
                                                        <div className="form-group col-md-6">
                                                            <label>Associate Business Verticals<span className="astrick">*</span></label>
                                                            <div className='custom-select-drop dropdown'>
                                                               
                                                             <select className="form-control selectpicker" 
                                                                  title={"Select Category"}
                                                                  name="categories"
                                                                  value={this.state.categories}
                                                                  disabled
                                                                  required
                                                                  >
                                                                  {
                                                                    mainvendorcategory.map((items, j) => {
                                                                      return (
                                                                        <option value={items.category_name} data-cat={items.first_category_id} key={ j + '1'}>{items.category_name}</option>
                                                                      )
                                                                    })
                                                                  }
                                                             </select>


                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>

                                              

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Key Information</span>
                                                        </div>
                                                        
                                                        <div className="form-group col-md-12">
                                                            <label>Pre Requisites</label>
                                                            <Editor
                                                            onEditorChange={this.handleEditorPrerequisites}
                                                            value={this.state.prerequisites}
                                                            apiKey={TINY_EDITOR}
                                                            init={{
                                                            height: 200,
                                                            plugins: [
                                                            'lists link image paste'
                                                            ],
                                                            toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                                                            }}
                                                            />  
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Contact Person <span className="astrick">*</span></label>
                                                            <input type="text" name="contact_person" value={this.state.contact_person}
                                                                 disabled className="form-control" />
                                                            {this.validator.message('Contact Person', this.state.contact_person, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Contact No <span className="astrick">*</span></label>
                                                            <input type="text" name="contact_no" value={this.state.phone_number}
                                                                 disabled className="form-control" />
                                                            {/* {this.validator.message('Contact No', this.state.contact_no, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })} */}
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>Email Id<span className="astrick">*</span></label>
                                                            <input type="email" name="email_id"
                                                                value={this.state.email_id}
                                                                onChange={this.handleChange} disabled className="form-control" />
                                                            {this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })}
                                                            {/* {this.validator.message('Email Id', this.state.email_id, 'required|email', { className: 'text-danger' })} */}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Type<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.tution_type}
                                                                    
                                                                    className='form-control selectpicker'
                                                                    name="tution_type" title='Select'>
                                                                    {this.state.tutionList.length > 0 &&
                                                                        this.state.tutionList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                               
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Student Ratio <span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.student_ratio}
                                                                    name="student_ratio"
                                                                    id="student_ratio"
                                                                    disabled
                                                                    onChange={this.handleSelect}
                                                                    className="form-control selectpicker"
                                                                    multiple title='Select'
                                                                >
                                                                    <option value='1' >
                                                                        One to One
                                                                    </option>
                                                                    <option value='2' >
                                                                        One to Many
                                                                    </option>
                                                                    <option value='3' >
                                                                        NA
                                                                    </option>
                                                                </select>
                                                                {this.validator.message('Student Ratio', this.state.student_ratio, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                     
                                                        <div className="form-group col-md-4">
                                                            <label>Brochure</label>
                                                            <input type="file" name="brochure" disabled class="form-control"  />
                                                            {(this.state.edit_brochure !='' && this.state.tempBrochure != '') &&
                                                            (
                                                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_brochure">

                                                                   <a href={this.state.tempBrochure}>View Brochure</a> 

                                                                </div>
                                                            )
                                                        }
                                                        </div>
                                                              
                                                         
                                                         
                                                        <div className="form-group col-md-6">
                                                            <label>About The Camp<span className="astrick">*</span></label>

                                                            <Editor
                                               
                                                            value={this.state.about_camp}
                                                            apiKey={TINY_EDITOR}
                                                            onEditorChange={this.handleEditorAbout}
                                                            init={{
                                                            height: 200,
                                                            plugins: [
                                                            'lists link image paste'
                                                            ],
                                                            toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                                                            }}
                                                            />
                                                          
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label>About The Partner<span className="astrick">*</span></label>

                                                            <Editor
                                                   
                                                            value={this.state.about_partner}
                                                            apiKey={TINY_EDITOR}
                                                            onEditorChange={this.handleEditorParnter}
                                                            init={{
                                                            height: 200,
                                                            plugins: [
                                                            'lists link image paste'
                                                            ],
                                                            toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                                                            }}
                                                            />
                                                          
                                                        </div>
                                                        
                                                        
                                                        
                                                    </div>
                                                </div>

                                                <div className="box-shadow-custom" id="curatedcampskeyinfo">
                                                    <div className="row">
                                                                                                              
                                                        <div className="form-group col-md-12">

                                                            <div class="panel panel-default">
                                                                <div class="panel-heading">Program Information</div>
                                                                <div class="panel-body">
                                                                    
                                                                    <div class="row parenttoclone">

                                                                    {this.state.formValues.map((element, idx) => (

                          
                                                                        <div className="row program form-group" style={{paddingTop:"10px"}}  key={idx}>
                                                                        
                                                                        <input
                                                                        type="hidden"
                                                                        className="form-control"
                                                                        name="pid" value={element.pid || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />

                                                                        <div className="form-group col-md-4">
                                                                        <label>Program Name <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={`Program #${idx + 1} name`}
                                                                        name="name" value={element.name || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                        
                                                                        <div className="form-group col-md-4">
                                                                        <label>Start Date <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        placeholder={`Program #${idx + 1} From Date`}
                                                                        name="fromdate" value={element.fromdate || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                      
                                                                        <div className="form-group col-md-4">
                                                                        <label>End Date <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        placeholder={`Program #${idx + 1} End Date`}
                                                                        name="enddate" value={element.enddate || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                         
                                                                        <div className="form-group col-md-4">
                                                                        <label>Start time <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="time"
                                                                        className="form-control"
                                                                        placeholder={`Program #${idx + 1} Start Time`}
                                                                        min="09:00" max="23:00"
                                                                        name="starttime" value={element.starttime || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                       
                                                                        <div className="form-group col-md-4">
                                                                         <label>End Time <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="time"
                                                                        className="form-control"
                                                                        placeholder={`Program #${idx + 1} End Time`}
                                                                        min="09:00" max="23:00"
                                                                        name="endtime" value={element.endtime || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>
 
                                                                         
                                                                        <div className="form-group col-md-4">
                                                                        <label>Program Fees (INR) <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={`Fees INR`}
                                                                        name="feeinr" value={element.feeinr || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                        
                                                                        <div className="form-group col-md-4">
                                                                        <label>Program Fee (USD) <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={`Fees USD`}
                                                                        name="feeusd" value={element.feeusd || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                        <div className="form-group col-md-4">
                                                                        <label>Duration (Hrs) <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={`Duration`}
                                                                        name="duration" value={element.duration || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                        <div className="form-group col-md-4">
                                                                        <label>Days per week <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder={`Days per week`}
                                                                        name="days" value={element.days || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                        <div className="form-group col-md-4">
                                                                        <label>No of Participants <span className="astrick">*</span></label>
                                                                        <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder={`No of Participants`}
                                                                        name="participants" value={element.participants || ""} onChange={e => this.handleChangev1(idx, e)} 
                                                                        />
                                                                        </div>

                                                                        { idx>0 && (
                                                                        <div className="form-group col-md-4 text-right">
                                                                        <button type="button" onClick={() => this.removeFormFieldsv1(idx)} className="small btn btn-primary btn-sm">
                                                                        Remove
                                                                        </button></div>

                                                                        )}

                                                                        </div>

                                                                        ) )}
                                          
                                                                    </div>

                                                                    <div class="form-group">
                                                                            
                                                                            <button type="button" onClick={() => this.addFormFieldsv1()} className="small btn btn-primary btn-sm">
                                                                        Add +
                                                                        </button>

                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Images</span>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>
                                                                Partner Profile Image <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                name="profile_image"
                                                                disabled
                                                                
                                                                className="form-control"
                                                            />
                                                            {/* {this.validator.message('Banner Image', this.state.images, 'checkExist', { className: 'text-danger error-msg' })} */}
                                                        </div>
                                                        {(this.state.edit_profile_image != '' || this.state.tempProfile!='') &&
                                                            (
                                                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_profile_image">

                                                                    <img src={this.state.tempProfile ? this.state.tempProfile : IMGBASEURL+this.state.edit_profile_image} alt="Img" class="img-thumbnail" />

                                                                </div>
                                                            )
                                                        }

                                                        <div className="form-group col-md-4">
                                                            <label>
                                                                Banner Image <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                name="banner"
                                                                onChange={this.handleFile}
                                                                className="form-control"
                                                            />
                                                            {/* {this.validator.message('Banner Image', this.state.images, 'checkExist', { className: 'text-danger error-msg' })} */}
                                                        </div>
                                                        {(this.state.edit_banner != '' || this.state.tempBanner != '') &&
                                                            (
                                                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_banner">

                                                                    <img src={this.state.tempBanner ? this.state.tempBanner : IMGBASEURL+this.state.edit_banner} alt="Img" class="img-thumbnail" />

                                                                </div>
                                                            )
                                                        }
                                                        <div class="col-md-12 float-left mt-4 p-0">
                                                            <label>
                                                                Gallery Images <span className="astrick">*</span>
                                                            </label>
                                                        </div>

                                                        <div class="col-md-12 float-left mt-4 p-0">

                                                            <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                                                {/* <span class="col-md-12 account-details-text float-left p-0">Image</span> */}
                                                                <div className='upload-wizard' style={{height:"255px"}}>
                                                                    <div className='upload-thumb'>
                                                                        <ul className='list-inline'>
                                                                            {this.state.attachment_file.map((file_data, index) => {

                                                                                var file_url;
                                                                                if (file_data.name) {
                                                                                    let url = file_data.image_thumb ? file_data.image_thumb : '';
                                                                                    if (url != '') {
                                                                                        file_url = file_data.image_thumb;
                                                                                    } else {
                                                                                        file_url = URL.createObjectURL(file_data);
                                                                                    }
                                                                                    let imgurl = file_url;

                                                                                    // var file_url = URL.createObjectURL(file_data)
                                                                                    // var file_name = file_data.name
                                                                                    if (file_data.type === 'application/pdf') {
                                                                                        var blob = file_url
                                                                                        //console.log('blob_url', file_data.name)
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='image'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                
                                                                                            </li>
                                                                                        )
                                                                                    } else {
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={imgurl}
                                                                                                        alt='image'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                               
                                                                                                
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                }
                                                                            })}
                                                                            <li className='addMore'>
                                                                                <input
                                                                                    type='file'
                                                                                    name='imgInp[]'
                                                                                    disabled
                                                                                    id='imgInp2'
                                                                                    className='add_img'
                                                                                    multiple
                                                                                    
                                                                                />
                                                                                <a href='javascript:;' className='add-more'>
                                                                                    <div>
                                                                                        <img src={'../../../assets/images/upload-icon.svg'} alt='icon' />
                                                                                        Add more
                                                                                    </div>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            {/* {this.validator.message('gallery images', this.state.attachment_file, 'required', { className: 'text-danger error-msg' })} */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-xs-4 ">
                                                    <label>Camp Status:</label>
                                                    <select name="approval_status" className="form-control" onChange={this.handleChange} >
                                                            <option value="">Select Status</option>
                                                            <option value="1" selected={this.state.approval_status == 1}>Approved</option>
                                                            <option value="0" selected={this.state.approval_status == 0}>Rejected</option>
                                                    </select>
                                                      
                                                </div>

                                                <div className="col-md-4 col-xs-4 ">
                                                    <label>Published:</label>
                                                    <select name="published" className="form-control" onChange={this.handleChange} >
                                                            <option value="">Select Status</option>
                                                            <option value="1" selected={this.state.published == 1}>Yes</option>
                                                            <option value="0" selected={this.state.published == 0}>No</option>
                                                    </select>
                                                      
                                                </div>

                                                <div className="col-md-12 col-xs-12">&nbsp;</div>
                                                <div className="col-md-12 col-xs-12 btn-bdr">
                                                    <button id="btnSubmit" className="btn btn-blue">Submit</button>&nbsp;
                                                    <button id="btnDelete" className="btn btn-blue" onClick={this.deleteCamp}>Delete</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                  </div>
                    
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default bewiseEditCuratedCamp;


// WEBPACK FOOTER //
// ./src/components/bewise/bewiseEditCuratedCamp.jsx